import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { Product } from '../../../core/models/product'
import chaining from '../../../core/helpers/chaining';
import { Crumb } from '../../../core/models/crumb';
import { SKU } from '../../models/sku';

@Component({
  selector: 'app-product-size-row',
  templateUrl: './product-size-row.component.html',
  styleUrls: ['./product-size-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSizeRowComponent {
    @Input() size: string


    constructor() {

        
    }
  
}
